import { Button, FormControl, Grid, Icon, InputLabel, MenuItem, Paper, Select, Stack, TextField, Tooltip } from '@mui/material';
import React,{useState} from 'react';
import {Link as RLink} from 'react-router-dom';


const ListFilter = (props:any)=>{

    const [Status,setStatus] = useState('')
    const [Term,setTerm] = useState('')
    
    const handlerChangeTerm = (e:any)=> setTerm(e.target.value)

    const handlerClickSearch = ()=>{
        props.onChangeFilter({page:1,status:Status,term:Term});
    }

    const handlerClickClear = ()=>{
        props.onChangeFilter({status:'',page:1});
        setTerm('');
        setStatus('');
    }

    
    return (
        <>
            <Grid container spacing={3} >
                <Grid item md={3} sm={6} xs={12}>
                    <TextField variant="outlined" size="small" fullWidth label="Search by Customer Domain / Subscription" value={Term} onChange={handlerChangeTerm} />
                </Grid>
                <Grid item md={2} sm={6} xs={6}>
                    <Tooltip title="Search">
                        <Button size="large" variant="contained" color="primary" onClick={handlerClickSearch}>
                            <Icon>search</Icon>
                        </Button>
                    </Tooltip>
                    &nbsp;
                    <Tooltip title="Clear Search">
                        <Button size="large" variant="contained" onClick={handlerClickClear}>
                            <Icon>settings_backup_restore</Icon>
                        </Button>
                    </Tooltip>
                </Grid> 
                {!props.noNewConfig &&
                <Grid item md={7} sm={6} xs={6}>
                    <Stack direction="row" justifyContent="right" >
                        <Button variant="contained" color="secondary" onClick={props.onShowELPModel}>
                            <Icon>post_add</Icon> &nbsp; New Configuration T&M
                        </Button>
                    </Stack>
                </Grid> 
                }
            </Grid>

            
        </>
    )
}

export default ListFilter;